import {useOrderStatuses} from '../hooks';

const withOrderStatuses = (Component) => {
  return (props) => {
    const statuses = useOrderStatuses();
    return <Component statuses={statuses} {...props}/>;
  }
};

export default withOrderStatuses;
